import gql from "graphql-tag";

/**
 * Backend schemas have drifted historically around what `getCurrentUser` returns.
 * Some deployments expose a minimal `LoginUser`/`User` shape that does not
 * include role flags on this query, while other deployments expose full
 * profile fields.
 *
 * To prevent GraphQL validation failures (and blank screens), we only request
 * fields that are guaranteed to exist on the minimal type.
 */
const CURRENT_USER = gql`
  query GetCurrentUser {
    getCurrentUser {
      id
      email
    }
  }
`;

export interface CurrentUser {
  id: string;
  email: string;
  role?: string;

  // Optional profile fields (may not exist on minimal schema)
  firstName?: string;
  lastName?: string;
  isAdmin?: boolean;
  isArtist?: boolean;
  isBeneficiary?: boolean;
  emailVerified?: boolean;
  updatedAt?: string;
}

export interface CurrentUserQueryResponse {
  getCurrentUser: CurrentUser;
  // Optional legacy aliases (some parts of the app expect them)
  me?: CurrentUser;
  user?: CurrentUser;
}

export default CURRENT_USER;
